import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { PainPoints } from './components/PainPoints';
import { Modules } from './components/Modules';
import { KoreanWave } from './components/KoreanWave';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { FinalCTA } from './components/FinalCTA';
import { Conclusion } from './components/Conclusion';
import { PurchaseNotification } from './components/PurchaseNotification';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { CountdownBar } from './components/CountdownBar';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-brand-50 font-sans selection:bg-accent-500 selection:text-white pb-16 md:pb-0" data-id="element-0">
      <CountdownBar data-id="element-1" />
      <Hero data-id="element-2" />
      <Stats data-id="element-3" />
      <PainPoints data-id="element-4" />
      <Modules data-id="element-5" />
      <KoreanWave data-id="element-6" />
      <Bonuses data-id="element-7" />
      <Pricing data-id="element-8" />
      <Testimonials data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Conclusion data-id="element-11" />

      <footer className="bg-brand-950 text-brand-500 py-6 md:py-8 text-center text-xs md:text-sm border-t border-brand-900" data-id="element-12">
        <div className="container mx-auto px-4" data-id="element-13">
          <p className="mb-1 text-brand-400" data-id="element-14">
            <span className="font-bold text-white" data-id="element-15">감사합니다</span> · Gracias
            por tu confianza
          </p>
          <p data-id="element-16">
            © {new Date().getFullYear()} Profe Coreano Pro. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <PurchaseNotification data-id="element-17" />
      <StickyMobileCTA data-id="element-18" />
      <MetaPixel pixelId="3402382169937662" data-id="element-19" />
    </div>;
}